import { useAppSelector } from 'app/hooks';
import { useMemo } from 'react';
import { recommendedComparedIds } from './recommended-compared-ids';
import useDuctedRailSections from './use-ducted-rail-sections';

export default function useRecommendedComparedIds(
  comparedIdByCardId: ReadonlyMap<string, string>
): ReadonlySet<string> {
  const { sections } = useDuctedRailSections();
  const systemsToCompare = useAppSelector(
    (state) => state.systems.systemsToCompare
  );
  return useMemo(
    () =>
      recommendedComparedIds(sections, comparedIdByCardId, systemsToCompare),
    [sections, comparedIdByCardId, systemsToCompare]
  );
}
